import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import * as React from 'react';

export interface CheckboxProps extends ChakraCheckbox.RootProps {
  icon?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  rootRef?: React.Ref<HTMLLabelElement>;
  onChange?: () => void;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(props, ref) {
  const { icon, children, inputProps, rootRef, onChange, onCheckedChange, ...rest } = props;

  // Handle both onChange and onCheckedChange
  const handleCheckedChange: ChakraCheckbox.RootProps['onCheckedChange'] = (details) => {
    if (onChange) {
      onChange();
    }
    if (onCheckedChange) {
      onCheckedChange(details);
    }
  };

  return (
    <ChakraCheckbox.Root cursor={'pointer'} ref={rootRef} onCheckedChange={handleCheckedChange} {...rest}>
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control>{icon || <ChakraCheckbox.Indicator />}</ChakraCheckbox.Control>
      {children != null && <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>}
    </ChakraCheckbox.Root>
  );
});
